module.exports = __webpack_public_path__ + "img/pattern.423f5d50.svg";